import * as React from "react";
import * as Scrivito from "scrivito";
import cx from "classnames";

import s from "./TextFooterWidget.module.scss";

interface TextFooterWidgetProps {
  widget?: Scrivito.Widget;
}

Scrivito.provideComponent(
  "TextFooterWidget",
  ({ widget }: TextFooterWidgetProps) => {
    if (!widget) return null;
    const title = widget.get("title") && (
      <Scrivito.ContentTag
        content={widget}
        attribute="title"
        tag="h5"
        id="footer-text__title"
      />
    );

    const text = widget.get("text") && (
      <Scrivito.ContentTag content={widget} attribute="text" tag="div" />
    );

    return (
      <div className={cx("row", s.footerWidgetText)}>
        <div className="col-md-12">
          <aside>
            {title}
            {text}
          </aside>
        </div>
      </div>
    );
  },
);
